(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carousel"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
       $(".products-responsive").slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
		dots: false,		
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 3,
				slidesToScroll: 3
			  }
			},
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			  }
			},
			{
			  breakpoint: 500,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			  }
			}
		  ]
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
       $(".featured-collections").slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
		dots: false,		
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 3,
				slidesToScroll: 3
			  }
			},
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			  }
			},
			{
			  breakpoint: 500,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			  }
			}
		  ]
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-products"] && !window.DesignMode) return;
  try {
    
$(document).ready(function(){
       $(".products-responsive").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
		dots: false,		
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 3,
				slidesToScroll: 3
			  }
			},
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			  }
			},
			{
			  breakpoint: 500,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			  }
			}
		  ]
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-bar-carousel"] && !window.DesignMode) return;
  try {
    
 $(document).ready(function(){
       $(".brands-responsive").slick({
        dots: true,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6,
		dots: false, 
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 6,
				slidesToScroll: 6
			  }
			},
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			  }
			},
			{
			  breakpoint: 500,
			  settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			  }
			}
		  ]
      });
    });

  } catch(e) { console.error(e); }
})();
})();
